import React from "react"
import { createRoot } from "react-dom/client"
import { RouterProvider } from "react-router/dom"
import createAppRouter from "src/router/create-app-router"
import Providers from "src/router/providers"
import { setupSessionStorageSync } from "@myvp/shared/src/functions/sync-session-storage"
import { updateHandlersForSchedulePreviewFilterOptions } from "@myvp/study-preview/src/schedule-preview-filter-options"

if (process.env.NODE_ENV === "production") {
  const sha = process.env.REACT_APP_SHA
  const gitlabLink =
    process.env.REACT_APP_release !== "true"
      ? `, https://gitlab.veevadev.com/myveeva-clinicaltrials/web/-/commits/${sha}`
      : ""
  // oxlint-disable-next-line no-console
  console.log(
    `App Version ${process.env.REACT_APP_VERSION}, ${sha}${gitlabLink}`
  )
}

const root = createRoot(document.getElementById("root") as HTMLElement)
{
  let ui: React.ReactNode = <RouterProvider router={createAppRouter()} />

  ui = <Providers>{ui}</Providers>

  // global suspense that renders nothing for the fallback to avoid throwing when someone forgets to put a suspense
  ui = <React.Suspense fallback={null}>{ui}</React.Suspense>

  // StrictMode should be at the top
  ui = <React.StrictMode>{ui}</React.StrictMode>

  root.render(ui)
}

setupSessionStorageSync({
  updateHandlers: {
    ...updateHandlersForSchedulePreviewFilterOptions,
  },
})
